import * as Sentry from '@sentry/vue';
export default (function (_ref) {
  var router = _ref.router,
    Vue = _ref.Vue;
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      Vue: Vue,
      dsn: 'https://9dd1c3b8a083485aa5c07f08a77c2f7c@o78498.ingest.sentry.io/4505740882804736',
      integrations: [new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'portal.ozeit.com.au'],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }), new Sentry.Replay()],
      // Performance Monitoring
      tracesSampleRate: 1.0,
      // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: 0.1,
      // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
});